import React from "react";
import PropTypes from "prop-types";
import { PUBLIC_ASSETS_URL } from "../../../config";
import { Card, Select, Radio } from "antd";
import { FileTextOutlined } from "@ant-design/icons";

const TitleBox = props => {
  return (
    <Card bodyStyle={{ textAlign: "center", padding: "32px 0" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <img alt="OPAL Logo" src={`${PUBLIC_ASSETS_URL}/opal_logo.png`} height={30} />
        <h2 style={{ fontSize: 32, margin: 0 }}> - {props.text}</h2>
      </div>
      <div style={{ margin: 8 }}>
        <Radio.Group onChange={e => props.onStandardChange(e.target.value)} value={props.standardCurrent} buttonStyle="solid" size="small">
          {props.standards.map(s => (
            <Radio.Button key={s} value={s}>
              {s.toUpperCase().replace("_", " ")}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
      <div>
        {props.versionHidden ? null : (
          <Select value={props.currentVersion} onChange={props.onVersionChange} disabled={props.versionDisabled} size="small" style={{ width: 60 }}>
            {props.versionOptions.map((v, i) => (
              <Select.Option value={v} key={i}>
                {v}
              </Select.Option>
            ))}
          </Select>
        )}
        <a href={props.methodologyLink} target="_new" style={{ marginLeft: 8 }}>
          <FileTextOutlined /> Methodology
        </a>
      </div>
    </Card>
  );
};
TitleBox.propTypes = {
  standards: PropTypes.arrayOf(PropTypes.string),
  standardCurrent: PropTypes.string,
  onStandardChange: PropTypes.func,
  methodologyLink: PropTypes.string, // https url
  text: PropTypes.string,
  currentVersion: PropTypes.string,
  versionOptions: PropTypes.arrayOf(PropTypes.string),
  onVersionChange: PropTypes.func,
  versionDisabled: PropTypes.bool,
  versionHidden: PropTypes.bool
};

export default TitleBox;
